// extracted by mini-css-extract-plugin
export default {"filter-control":"FilterControl_filter-control__6otuL","input-wrapper":"FilterControl_input-wrapper__asAF9","icon":"FilterControl_icon__X3RV5"};